import React from 'react'
import { Box, Grid, Typography } from '@material-ui/core'

export const Socios = ({ socios }) => {
  return (
    <Box mt={1}>
      <Grid spacing={1} container>
        <Grid item xs={12}>
          <Typography variant='h6'>Socios</Typography>
        </Grid>
        {socios.map(socio => (
          <Grid item xs={12}>
            <Typography>
              <b>Nome Empresarial:</b> {socio.nomeEmpresarial}
            </Typography>
            <Typography>
              <b>Qualificação:</b> {socio.qualificacao}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}